/** Strip legacy rep/unit suffixes from older leaderboard totals. Backend formats result_display. */
export function formatCommunityResultDisplay(display) {
	if (!display) return display;
	return display.replace(/\s+(reps|units?)\s*$/i, '').trim();
}
